module.exports = __webpack_public_path__ + "img/GS_Profile-Unathi Adekanbi.9c623d74.png";